import { render, staticRenderFns } from "./serviceNotice.vue?vue&type=template&id=6410c94c&"
import script from "./serviceNotice.vue?vue&type=script&lang=js&"
export * from "./serviceNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6410c94c')) {
      api.createRecord('6410c94c', component.options)
    } else {
      api.reload('6410c94c', component.options)
    }
    module.hot.accept("./serviceNotice.vue?vue&type=template&id=6410c94c&", function () {
      api.rerender('6410c94c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configure/serviceNotice.vue"
export default component.exports